/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Organised_ByInputs */

const th_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`จัดโดย ${i?.name}`)
};

const en_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Organised by ${i?.name}`)
};

const ja_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`主催: ${i?.name}`)
};

const zh_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`由 ${i?.name} 主办`)
};

const es_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Organizado por ${i?.name}`)
};

const pt_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Organizado por ${i?.name}`)
};

const id_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Diselenggarakan oleh ${i?.name}`)
};

const fr_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Organisé par ${i?.name}`)
};

const tl_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inorganisa ni ${i?.name}`)
};

const vi_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Do ${i?.name} tổ chức`)
};

const ko_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 주최`)
};

const de_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Veranstaltet von ${i?.name}`)
};

const ru_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Организатор: ${i?.name}`)
};

const tr_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} tarafından düzenleniyor`)
};

const it_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Organizzato da ${i?.name}`)
};

const pl_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Organizuje ${i?.name}`)
};

const uk_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Організує ${i?.name}`)
};

const hi_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} द्वारा आयोजित`)
};

const ar_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`من تنظيم ${i?.name}`)
};

const ms_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dianjurkan oleh ${i?.name}`)
};

const bn_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} আয়োজিত`)
};

const zh_tw2_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`由 ${i?.name} 主辦`)
};

const zh_hk2_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`由 ${i?.name} 主辦`)
};

const ur_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} کے زیرِ اہتمام`)
};

const fa_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`به کوشش ${i?.name}`)
};

const sw_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Imeandaliwa na ${i?.name}`)
};

const nl_organised_by = /** @type {(inputs: Organised_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Georganiseerd door ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Organised by {name}" |
*
* @param {Organised_ByInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const organised_by = /** @type {((inputs: Organised_ByInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organised_ByInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_organised_by(inputs)
	if (locale === "ja") return ja_organised_by(inputs)
	if (locale === "zh") return zh_organised_by(inputs)
	if (locale === "es") return es_organised_by(inputs)
	if (locale === "pt") return pt_organised_by(inputs)
	if (locale === "id") return id_organised_by(inputs)
	if (locale === "fr") return fr_organised_by(inputs)
	if (locale === "tl") return tl_organised_by(inputs)
	if (locale === "vi") return vi_organised_by(inputs)
	if (locale === "ko") return ko_organised_by(inputs)
	if (locale === "de") return de_organised_by(inputs)
	if (locale === "ru") return ru_organised_by(inputs)
	if (locale === "tr") return tr_organised_by(inputs)
	if (locale === "it") return it_organised_by(inputs)
	if (locale === "pl") return pl_organised_by(inputs)
	if (locale === "uk") return uk_organised_by(inputs)
	if (locale === "hi") return hi_organised_by(inputs)
	if (locale === "ar") return ar_organised_by(inputs)
	if (locale === "ms") return ms_organised_by(inputs)
	if (locale === "bn") return bn_organised_by(inputs)
	if (locale === "zh-TW") return zh_tw2_organised_by(inputs)
	if (locale === "zh-HK") return zh_hk2_organised_by(inputs)
	if (locale === "ur") return ur_organised_by(inputs)
	if (locale === "fa") return fa_organised_by(inputs)
	if (locale === "sw") return sw_organised_by(inputs)
	if (locale === "nl") return nl_organised_by(inputs)
	return en_organised_by(inputs)
});